import React from "react";
import { IconButton } from "@chakra-ui/react";
import { ChevronLeftIcon } from "@chakra-ui/icons";

interface BackButtonProps {
  onBack: () => void;
  className?: string;
  color?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ onBack, className, color }) => {
  return (
    <IconButton
      className={className}
      variant="ghost"
      aria-label="back"
      icon={<ChevronLeftIcon w={8} h={8} />}
      onClick={onBack}
      color={color || "defaultColor"}
      _hover={{ bg: "transparent" }}
    />
  );
};

export default BackButton;
